export default __webpack_public_path__ + "static/media/icn-fuel-pistol-vehicle.168948b2.svg";